(() => {
  'use strict';
  const config = document.querySelector('script[data-bv-blog-stock]');
  const root = document.querySelector('.article__content');
  if (!config || !root || root.dataset.bvStockBound) return;
  root.dataset.bvStockBound = 'true';
  const settings = config.dataset;
  const base = new URL((settings.root || '/').replace(/\/+$/, '') + '/', location.origin);
  if (base.origin !== location.origin) return;
  const fallback = new URL(settings.fallback || base.href, location.origin);
  if (fallback.origin !== location.origin) return;
  const entries = [];
  const cache = new Map();
  const queue = [];
  let active = 0;
  const ttl = 60000;

  function productURL(link) {
    try {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
      return url;
    } catch (_) { return null; }
  }

  function request(url) {
    const key = url.href;
    const prior = cache.get(key);
    if (prior && Date.now() - prior.time < ttl) return prior.promise;
    const promise = new Promise((resolve) => { queue.push({ url, resolve }); });
    cache.set(key, { promise, time: Date.now() });
    drain();
    return promise;
  }

  function drain() {
    while (active < 3 && queue.length) {
      const job = queue.shift();
      active += 1;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 5000);
      fetch(job.url.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(async (response) => {
          if (response.status === 404) return { state: 'removed' };
          if (!response.ok) return { state: 'unknown' };
          const product = await response.json();
          if (!Array.isArray(product.variants) || !product.id) return { state: 'unknown' };
          return { state: 'product', product };
        })
        .catch(() => ({ state: 'unknown' }))
        .then(job.resolve)
        .finally(() => { clearTimeout(timer); active -= 1; drain(); });
    }
  }

  function setState(entry, state) {
    if (state === 'unknown') return;
    entry.state = state;
    if (state !== 'removed') {
      for (const item of entry.suspendedLinks) {
        item.link.setAttribute('href', item.href);
        if (item.title === null) item.link.removeAttribute('title');
        else item.link.setAttribute('title', item.title);
      }
      entry.suspendedLinks = [];
    }
    if (state === 'available') {
      if (entry.changed) {
        entry.button.disabled = false;
        entry.button.innerHTML = entry.originalHTML;
        if (entry.originalAria === null) entry.button.removeAttribute('aria-label');
        else entry.button.setAttribute('aria-label', entry.originalAria);
        entry.button.removeAttribute('aria-disabled');
        entry.note?.remove();
        entry.note = null;
        entry.changed = false;
      }
      return;
    }
    entry.changed = true;
    entry.button.disabled = true;
    entry.button.setAttribute('aria-disabled', 'true');
    const label = state === 'removed' ? settings.removed : settings.soldout;
    entry.button.textContent = label;
    entry.button.setAttribute('aria-label', label);
    if (!entry.note) {
      entry.note = document.createElement('p');
      entry.note.className = 'bv-blog-stock-note';
      entry.note.style.cssText = 'font-size:14px;line-height:1.5;margin:12px 0;';
      entry.note.setAttribute('role', 'status');
      entry.button.closest('product-form').after(entry.note);
    }
    entry.note.replaceChildren();
    entry.note.append(document.createTextNode((state === 'removed' ? settings.removedNote : settings.soldoutNote) + ' '));
    const alternative = document.createElement('a');
    alternative.href = fallback.href;
    alternative.textContent = settings.alternatives;
    entry.note.append(alternative);
    if (state === 'removed') {
      for (const link of root.querySelectorAll('a[href]')) {
        const url = productURL(link);
        if (!url || url.pathname.split('/products/')[1].replace(/\/$/, '') !== entry.handle) continue;
        entry.suspendedLinks.push({ link, href: link.getAttribute('href'), title: link.getAttribute('title') });
        link.removeAttribute('href');
        link.setAttribute('title', settings.removed);
      }
    }
  }

  async function check(entry) {
    if (entry.pending || !entry.form.isConnected) return;
    entry.pending = true;
    const variantID = entry.input.value;
    const result = await request(entry.endpoint);
    entry.pending = false;
    if (entry.input.value !== variantID || !entry.form.isConnected) return;
    if (result.state === 'removed') { setState(entry, 'removed'); return; }
    if (result.state !== 'product') return;
    const variant = result.product.variants.find(item => String(item.id) === variantID);
    if (!variant) {
      if (result.product.variants.length < 250) setState(entry, 'unavailable');
      return;
    }
    if (typeof variant.available !== 'boolean') return;
    setState(entry, variant.available ? 'available' : 'unavailable');
  }

  for (const form of root.querySelectorAll('product-form form.js-product-form')) {
    const input = form.querySelector('input[type="hidden"][name="id"]');
    const button = form.querySelector('button[name="add"][type="submit"]');
    if (!input || !/^\d+$/.test(input.value) || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') continue;
    if (form.querySelector('[name="selling_plan"]')) continue;
    let scope = form.parentElement.parentElement;
    let link;
    while (scope && scope !== root && root.contains(scope)) {
      if (scope.querySelectorAll('product-form form').length !== 1) break;
      link = [...scope.querySelectorAll('a[href]')].find(anchor => productURL(anchor));
      if (link) break;
      scope = scope.parentElement;
    }
    if (!link) continue;
    const url = productURL(link);
    const handle = url.pathname.split('/products/')[1].replace(/\/$/, '');
    const endpoint = new URL('products/' + handle + '.js', base);
    const entry = { form, input, button, handle, endpoint, state: 'unknown', originalHTML: button.innerHTML,
      originalAria: button.getAttribute('aria-label'), changed: false, suspendedLinks: [], pending: false, seen: false };
    entries.push(entry);
    form.addEventListener('submit', (event) => {
      if (entry.state === 'removed' || entry.state === 'unavailable') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((records) => {
      for (const record of records) {
        if (!record.isIntersecting) continue;
        const entry = entries.find(item => item.form === record.target);
        if (entry) { entry.seen = true; check(entry); }
        observer.unobserve(record.target);
      }
    }, { rootMargin: '800px 0px' });
    entries.forEach(entry => observer.observe(entry.form));
  } else {
    entries.forEach(entry => { entry.seen = true; check(entry); });
  }
  const refresh = () => { if (document.visibilityState !== 'hidden') entries.filter(entry => entry.seen).forEach(check); };
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', refresh);
})();
